import { render, staticRenderFns } from "./xgmmDialog.vue?vue&type=template&id=77a44e6e&scoped=true"
import script from "./xgmmDialog.vue?vue&type=script&lang=js"
export * from "./xgmmDialog.vue?vue&type=script&lang=js"
import style0 from "./xgmmDialog.vue?vue&type=style&index=0&id=77a44e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a44e6e",
  null
  
)

export default component.exports